// extracted by mini-css-extract-plugin
export default {"topPaddedRow":"orders__topPaddedRow__p0EO9P","blobColumn":"orders__blobColumn__O3UU8G"};